import React from 'react';

import { FormattedTooltipProps, Paragraph } from 'DesignLibrary/atoms';
import { TooltipPlanDetails } from 'DesignLibrary/molecules';
import Text from 'Shared/Text';

import { Cell, Dash, RowContainer } from './styled';

interface CompareTableRowProps {
  rowHeader?: string | JSX.Element;
  rowHeaderTooltip?: string | FormattedTooltipProps;
  columnOne: JSX.Element | number | null;
  columnTwo: JSX.Element | number | null;
  columnThree?: JSX.Element | number | null;
  asterisk?: boolean;
  size?: 'small' | 'medium' | 'large';
  hideTooltip?: boolean;
  keyHint: string;
  alignStart?: boolean;
}

export const CompareTableRow = ({
  rowHeader,
  rowHeaderTooltip,
  columnOne,
  columnTwo,
  columnThree,
  asterisk = false,
  size = 'large',
  hideTooltip = false,
  keyHint,
  alignStart = false,
}: CompareTableRowProps) => (
  <RowContainer role="row" data-testid={keyHint}>
    <Cell
      className="row-header"
      hideRowHeader={!rowHeader}
      role="rowheader"
      gray={!rowHeader}
      size={size}
      data-testid={`${keyHint}-row-header`}
    >
      <div>
        {asterisk && (
          <div className="asterisk">
            <Paragraph size="mini">
              * <Text field="health_section.compare_plan_text.compareModal.afterDeductibleAsterisk" />
            </Paragraph>
          </div>
        )}
        {rowHeader && !hideTooltip && (
          <TooltipPlanDetails keyHint={keyHint} tooltip={rowHeaderTooltip || ''}>
            {rowHeader}
          </TooltipPlanDetails>
        )}
        {hideTooltip && <Paragraph color="--colors-gray-600">{rowHeader}</Paragraph>}
      </div>
    </Cell>
    <Cell alignStart={alignStart} role="cell" size={size} data-testid={`${keyHint}-plan-1`}>
      <div>{columnOne || <Dash />}</div>
    </Cell>
    <Cell alignStart={alignStart} role="cell" size={size} data-testid={`${keyHint}-plan-2`}>
      <div>{columnTwo || <Dash />}</div>
    </Cell>
    <Cell alignStart={alignStart} role="cell" size={size}>
      <div>{columnThree || <Dash />}</div>
    </Cell>
  </RowContainer>
);
